export const T = {
  en_GB: {
    title: "API rate limit",
    requestsPerMinute: "requests per minute",
    requestsPerSeconds: (seconds: string) => `requests per ${seconds} seconds`,
    inputPerMinute: "Requests per minute",
    inputPerSeconds: (seconds: string) => `Requests per ${seconds} seconds`,
    override: "Override",
    default: "Default",
    sharedPrefix: "Shared by all of the tenant's API keys and endpoints. The default is",
    requests: "requests",
    ownAllowance: "; this tenant has its own allowance.",
    inheritsDefault: ", which this tenant inherits.",
    save: "Save",
    resetToDefault: "Reset to default",
    managedByQuantfolio: "Managed by Quantfolio",
    saved: "Saved",
    reset: "Reset to default",
    saveFailed: "Failed to save the API rate limit",
  },
  nb_NO: {
    title: "API-grense",
    requestsPerMinute: "forespørsler per minutt",
    requestsPerSeconds: (seconds: string) => `forespørsler per ${seconds} sekunder`,
    inputPerMinute: "Forespørsler per minutt",
    inputPerSeconds: (seconds: string) => `Forespørsler per ${seconds} sekunder`,
    override: "Overstyrt",
    default: "Standard",
    sharedPrefix: "Deles av alle organisasjonens API-nøkler og endepunkter. Standard er",
    requests: "forespørsler",
    ownAllowance: "; denne organisasjonen har sin egen grense.",
    inheritsDefault: ", som denne organisasjonen arver.",
    save: "Lagre",
    resetToDefault: "Tilbakestill til standard",
    managedByQuantfolio: "Administreres av Quantfolio",
    saved: "Lagret",
    reset: "Tilbakestilt til standard",
    saveFailed: "Kunne ikke lagre API-grensen",
  },
} as const;
